export const SMARTLI_APPSTORE_URL =
  "https://smartli.ai/?utm_source=alidrop-app&utm_medium=sidebar&utm_campaign=sidebar";

export const SPOCKET_APPSTORE_URL =
  "https://apps.shopify.com/spocket?utm_source=alidrop&utm_medium=app&utm_campaign=us-eu";

export const SPOCKET_WEBSITE_URL =
  "https://www.spocket.co?utm_source=alidrop&utm_medium=app&utm_campaign=us-eu";

export const APP_ASSETS_BUCKET_URL =
  "https://alidrop-production-files.s3.us-east-1.amazonaws.com/files";

export const SPOCKET_APP_ASSETS_BUCKET_URL =
  "https://d3eyb8shadqthh.cloudfront.net";
